'use strict';

import debounce from 'lodash.debounce';

export default (() => {

    var _self,
        ui,
        state,
        wrap;

    return {

        init: function(options) {
            _self = this;

            if (options.wrap) {
                wrap = options.wrap;
            }

            if (wrap) {
                ui = {
                    phoneCta: document.querySelector('.js-header .l-constraint .header-cta'),
                    mobileNavToggles: document.querySelectorAll('.js-mobile-nav-toggle'),
                    dropdownItems: wrap.querySelectorAll('.js-nav-primary-dropdown-wrap'),
                    dropdownItemLinks: wrap.querySelectorAll('.js-nav-primary-dropdown-wrap > a')
                };

                _self.setState();
                _self.bindUIActions();
            }
        },

        bindUIActions: function() {
            $(window).on('load', _self.events.windowLoad);
            $(window).on('resize', debounce(_self.events.windowResize, 200));
            for (var i = 0; i <  ui.mobileNavToggles.length; i++) {
                ui.mobileNavToggles[i].addEventListener('click', _self.events.mobileNavToggleClick);
            }

            document.addEventListener('focus', _self.events.documentFocusChange, true);
            document.addEventListener('click', function() {
                _self.events.documentFocusChange(document.activeElement);
            });
            [].forEach.call(ui.dropdownItemLinks, function(link) {
                link.addEventListener('keydown', _self.events.dropdownItemLinkKeyDown);
            });
        },

        events: {
            windowLoad: function() {
                _self.setState();
                _self.checkItemOverflow();
            },

            windowResize: function() {
                _self.setState();
                _self.checkItemOverflow();
            },

            mobileNavToggleClick: function(e) {
                e.preventDefault();
                _self.toggleMobileNav();
            },

            mobileSearchTransitionEnd: function() {
                document.body.classList.toggle('is-showing-mobile-nav');
                document.body.removeEventListener('transitionend', _self.events.mobileSearchTransitionEnd);
            },

            dropdownItemLinkKeyDown: function(e) {
                if (e.which === 13 && state.mediaQuery === 'mq-large') {
                    if (!_self.isLinkShowingDropdown(e.target)) {
                        e.preventDefault();
                        _self.setOpenDesktopDropdown(e.target);
                    }
                }
            },

            documentFocusChange: function(e) {
                if (!_self.isChildOfActiveDropdown(e.target)) {
                    _self.setOpenDesktopDropdown();
                }
            }
        },

        setState: function() {
            state = state || {};

            state.dropdownItems = state.dropdownItems || [].map.call(ui.dropdownItems, function(item) {
                return {
                    elWrap: item,
                    elDropdown: item.querySelector('.js-nav-primary-dropdown'),
                    overflowing: item.overflowing || false
                };
            });

            state.dropdownItems = state.dropdownItems.map(function(item) {
                item.pos = item.elWrap.getBoundingClientRect().left;
                item.width = 450;
                return item;
            });

            state.windowWidth = window.innerWidth;

            // Determines the active media query from the css
            // so there's one source of truth (either 'mq-large' or 'mq-small')
            state.mediaQuery = (window.getComputedStyle(
                wrap, ':before'
            ).getPropertyValue('content') || '').replace(/\"|\'/g, '');
        },

        checkItemOverflow: function() {
            state.dropdownItems.forEach(function(item) {
                if ( (state.windowWidth - (item.pos + item.width) < 0) ) {
                    item.overflowing = true;
                } else {
                    item.overflowing = false;
                }
            });

            _self.repositionDropdown();
        },

        repositionDropdown: function() {
            state.dropdownItems.forEach(function(item) {
                if (item.overflowing) {
                    item.elWrap.classList.remove('opens-right');
                    item.elWrap.classList.add('opens-left');
                } else if (!item.overflowing) {
                    item.elWrap.classList.remove('opens-left');
                    item.elWrap.classList.add('opens-right');
                }
            });
        },

        toggleMobileNav: function() {
            if (document.body.classList.contains('is-showing-mobile-search')) {
                document.body.addEventListener('transitionend', _self.events.mobileSearchTransitionEnd);
                document.body.classList.remove('is-showing-mobile-search');
            } else {
                document.body.classList.toggle('is-showing-mobile-nav');
            }
        },

        isLinkShowingDropdown: function(target) {
            return target === state.openDropDownItem || target.parentNode === state.openDropDownItem;
        },

        isChildOfActiveDropdown: function(target) {
            if(!state.openDropDownItem) {
                return false;
            }

            var parent = $(target).closest(state.openDropDownItem);

            return parent && parent.length > 0;
        },

        setOpenDesktopDropdown: function(target) {
            [].forEach.call(ui.dropdownItems, function(item) {
                item.classList.remove('is-open');
            });

            if (target) {
                target.parentNode.classList.add('is-open');
                state.openDropDownItem = target.parentNode;
            } else {
                state.openDropDownItem = null;
            }
        },
    };
})();
